import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Table } from "@similarweb/pro-logic-components";
import { colorsPalettes, elevation } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

import type { TeamListItem } from "../../types/teams.types";

import { getTeamsColumns, type TeamsColumnHandlers } from "./columns";

const PAGE_SIZE = 20;

type TeamsTableProps = {
    rows: TeamListItem[];
    handlers: TeamsColumnHandlers;
    searchTerm: string;
    onSearchChange: (value: string) => void;
};

export const TeamsTable = ({ rows, handlers, searchTerm, onSearchChange }: TeamsTableProps) => {
    const { translate } = useTranslate();

    const columnConfig = useMemo(() => getTeamsColumns(translate, handlers), [translate, handlers]);

    return (
        <Stack
            flex="1"
            borderRadius="6px"
            background={colorsPalettes.carbon["0"]}
            boxShadow={elevation.Z1}
            overflow="hidden"
            data-automation="teams-management-table"
        >
            <Table<TeamListItem>
                data={rows}
                rowKey="teamId"
                columnConfig={columnConfig}
                pagination={{ pageSize: PAGE_SIZE }}
                withArrowButtons={false}
            >
                <Table.TableTop borderBottom>
                    <Table.TableTop.Filters
                        filters={[
                            {
                                filter: "search",
                                initialValue: searchTerm,
                                onSearchChange,
                                placeholder: translate("si.management.teams.search.placeholder"),
                            },
                        ]}
                    />
                </Table.TableTop>
            </Table>
        </Stack>
    );
};
